import { connect } from 'react-redux';
import { IntlProvider, addLocaleData } from 'react-intl';
import fi from 'react-intl/locale-data/fi'
import en from 'react-intl/locale-data/en'
import se from 'react-intl/locale-data/se'

// This function will map the current redux state to the props for the component that it is "connected" to.
// When the state of the redux store changes, this function will be called, if the props that come out of
// this function are different, then the component that is wrapped is re-rendered.
function mapStateToProps(state) {

    addLocaleData(fi);
    addLocaleData(se);
    addLocaleData(en);

    const { lang, messages } = state.locale;

    return { locale: lang, key: lang, messages: messages };
}

export default connect(mapStateToProps)(IntlProvider);


// WEBPACK FOOTER //
// ./src/ConnectedIntlProvider.js